<template>
  <path d="M21 10H3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21 6H3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21 14H3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21 18H3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</template>
